<template>
  <div>
    <el-form class="lesson-coll-item-form" ref="form" label-width="80px">
      <el-form-item label="类型">
        <el-select v-model="form.type" placeholder="请选择">
          <el-option label="生词" value="words">生词</el-option>
          <el-option label="语法 " value="grammar">语法</el-option>
          <el-option label="课文 " value="text">课文</el-option>
          <el-option label="小测试 " value="test">小测试</el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="标题">
        <el-input v-model="form.title" placeholder="要覆盖默认标题请写在这里"></el-input>
      </el-form-item>
      <el-form-item label="简介">
        <el-input type="textarea" v-model="form.intro" :autosize="{minRows:2}" resize="none"></el-input>
      </el-form-item>
      <el-form-item label="必备表达">
        <el-input type="textarea" v-model="form.expression" :autosize="{minRows:2}" resize="none"></el-input>
      </el-form-item>
      <el-form-item label="重点词汇">
        <el-input type="textarea" v-model="form.key_words" :autosize="{minRows:2}" resize="none"></el-input>
      </el-form-item>
      <el-form-item label="重点语法">
        <el-input type="textarea" v-model="form.key_grammar" :autosize="{minRows:2}" resize="none"></el-input>
      </el-form-item>
      <el-form-item label="时长">
        <el-input v-model="duration" placeholder="小节最高时长"></el-input>
      </el-form-item>
      <el-form-item label="免费开放">
        <el-switch v-model="form.free" :active-value="1" :inactive-value="0"></el-switch>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import utils from '@/js/utils'
export default {
  name: 'LessonCollItem',
  props: {
    lid: Number,
    unid: Number
  },
  data () {
    return {
      duration: null,
      form: {
        id: null,
        unid: this.unid,
        type: '',
        title: '',
        intro: '',
        expression: '',
        key_words: '',
        key_grammar: '',
        duration: null,
        free: 0,
        status: 1
      }
    }
  },
  methods: {
    reset (model) {
      this.form = Object.assign({
        id: null,
        type: '',
        title: '',
        intro: '',
        expression: '',
        key_words: '',
        key_grammar: '',
        duration: null,
        free: 0,
        status: 1
      }, model)
      this.duration = utils.asDuration(this.form.duration * 1000)
    },
    submit () {
      this.form.duration = Number.parseInt(utils.asMillisecond(this.duration) / 1000)
      var params = { ...this.form, unid: this.unid }
      if (this.form.id) {
        delete params.id
        return this.$http.put(this.$urls.lesson_coll_update, params, {
          params: { id: this.form.id }
        })
      } else {
        return this.$http.post(this.$urls.lesson_coll_create, params).then(data => {
          this.form.id = data.data.id
        })
      }
    }
  }
}
</script>
